import { firebaseApp } from "../../../firebase/firebaseClient";
import { getFunctions, httpsCallable } from "firebase/functions";

export const processCustomerBundle = async (
  guide_name: string,
  user_id: string
) => {
  const functions = getFunctions(firebaseApp);
  const addBundlesToProfile = httpsCallable(functions, "addBundlesToProfile");
  const { data } = await addBundlesToProfile({ guide_name, user_id });
  return data;
};
